// SS-1 — on-device store (IndexedDB). Audio chunks and photos live here until the server has verified the upload.
const DB = 'alvora-snag', VER = 1;
let dbp = null;
const open = () => dbp || (dbp = new Promise((res, rej) => {
  const r = indexedDB.open(DB, VER);
  r.onupgradeneeded = () => {
    const d = r.result;
    d.createObjectStore('chunks', { keyPath: 'key' }).createIndex('segment', 'segmentId');
    d.createObjectStore('segments', { keyPath: 'id' }).createIndex('inspection', 'inspectionId');
    d.createObjectStore('photos', { keyPath: 'id' }).createIndex('inspection', 'inspectionId');
    d.createObjectStore('inspections', { keyPath: 'id' });
  };
  r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error || new Error('IndexedDB unavailable'));
}));
const tx = async (store, mode, fn) => { const d = await open(); return new Promise((res, rej) => { const t = d.transaction(store, mode); const q = fn(t.objectStore(store)); t.oncomplete = () => res(q?.result); t.onerror = () => rej(t.error); t.onabort = () => rej(t.error || new Error('aborted')); }); };
const all = (store, index, value) => tx(store, 'readonly', (s) => (index ? s.index(index).getAll(value) : s.getAll()));

export const localStoreSupported = typeof indexedDB !== 'undefined';
export const persistStorage = async () => { try { return navigator.storage?.persist ? await navigator.storage.persist() : false; } catch { return false; } };

export const put = (store, row) => tx(store, 'readwrite', (s) => s.put(row));
export const get = (store, key) => tx(store, 'readonly', (s) => s.get(key));
export const del = (store, key) => tx(store, 'readwrite', (s) => s.delete(key));
export const segmentsOf = (inspectionId) => all('segments', 'inspection', inspectionId).then((r) => r.sort((a, b) => a.seq - b.seq));
export const photosOf = (inspectionId) => all('photos', 'inspection', inspectionId).then((r) => r.sort((a, b) => a.seq - b.seq));
export const chunksOf = (segmentId) => all('chunks', 'segment', segmentId).then((r) => r.sort((a, b) => a.idx - b.idx));
export const putChunk = (segmentId, idx, blob) => put('chunks', { key: `${segmentId}:${idx}`, segmentId, idx, blob, size: blob.size });
export const dropChunks = async (segmentId) => { for (const c of await chunksOf(segmentId)) await del('chunks', c.key); };
export const allLocalInspections = () => all('inspections');
export const segmentBlob = async (seg) => { const cs = await chunksOf(seg.id); return cs.length ? new Blob(cs.map((c) => c.blob), { type: seg.mime }) : null; };
